import { FormProvider } from 'react-hook-form';
import { useEditUserForm } from './hooks';
import { convertToPresentationProps } from './logics';
import { EditUserFormPresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者編集フォームのコンテナコンポーネント
 *
 * @param userId - 編集対象の利用者ID
 */
export const EditUserForm: React.FC<Props> = ({ userId }) => {
  const {
    state: { data, methods, isButtonDisabled, isEmailRequired, isPhoneNumberFieldVisible },
    actions: { handleOnSubmit },
  } = useEditUserForm(userId);

  const { isBillableFromEditable } = convertToPresentationProps({ data });

  return (
    <FormProvider {...methods}>
      <EditUserFormPresentation
        isButtonDisabled={isButtonDisabled}
        onSubmit={handleOnSubmit}
        isBillableFromEditable={isBillableFromEditable}
        isEmailRequired={isEmailRequired}
        isPhoneNumberFieldVisible={isPhoneNumberFieldVisible}
      />
    </FormProvider>
  );
};
